// import { consolidateStreamedStyles } from "styled-components";

const YEARS = 25;
const eachYear = (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const eachMonth = (Array.apply(null, { length: YEARS * 12 }).map(Number.call, Number)).map(x => (x + 1));
const lastMonthOfYear = (x, index) => (((index - 1) % 12) === 11);
const round2 = x => (parseFloat(x).toFixed(2));
const nonNegative = x => (x > 0 ? x : 0);

const seriesFutureHousePrice = ({ housePrice, futureHousePricePct}) => {
  const result = [ housePrice ];
  eachYear.forEach(year => {
    const prev = result[result.length - 1];
    const value = nonNegative(parseInt(prev) + (parseInt(prev) * (parseInt(futureHousePricePct) / 100)));
    result.push(value);
  });
  return result.map(round2);
};

const seriesNoRepayment = ({ loanTaken, interestTaken }) => {
  const monthlyResult = [ parseInt(loanTaken, 10) ];

  eachYear.forEach(month => {
    const prev = parseFloat(monthlyResult[monthlyResult.length - 1]);
    let monthInterest = 0;
    let previousValue = prev;

    [1,2,3,4,5,6,7,8,9,10,11,12].map((value, index) => {
      let currentInterest = (previousValue * (interestTaken / 100) / 12);

      monthInterest += currentInterest;
      previousValue += currentInterest;
    });

    const value = nonNegative(prev + monthInterest);
    monthlyResult.push(value);
  });

  return monthlyResult.map(round2);
};

const series = ({ loanTaken, interestTaken, period, monthlyPayment, stopRepayment }, title) => {
  const monthlyResult = [ parseInt(loanTaken, 10) ];

  eachYear.forEach(month => {
    const prev = parseFloat(monthlyResult[monthlyResult.length - 1]);
    let monthInterest = 0;
    let previousValue = prev;

    [1,2,3,4,5,6,7,8,9,10,11,12].map((value, index) => {
      let currentInterest = (previousValue * (interestTaken / 100) / 12);

      monthInterest += currentInterest;

      if(month > stopRepayment) {
        previousValue += currentInterest;
      }
      else
      {
        previousValue += currentInterest - (monthlyPayment / 12);
      }
    });

    let value = nonNegative( prev + monthInterest - monthlyPayment);

    if(month > stopRepayment)
    {
      value = nonNegative(((prev) + monthInterest));
    }
    monthlyResult.push(value);
  });

  return monthlyResult.map(round2);

  // if (title) {console.table(debug);}
  return [ loanTaken ].concat(monthlyResult.map(round2).filter(lastMonthOfYear));
};

const stopAfterZero = arr => {
  const zeroIndex = arr.findIndex(x => (x <= 0));
  return (zeroIndex !== -1) ? arr.slice(0, zeroIndex + 1) : arr;
};

const equityRetained = (index, futureHousePrice, noRepayments) => {
  return round2(futureHousePrice[index] - noRepayments[index]);
}

const futureTableCalc = (futureHousePrice, noRepayments, partialRepayment) => {
  return [
    {
      title: "Today",
      propertyValue: futureHousePrice[0],
      amountOwed: noRepayments[0],
      equity: equityRetained(0, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[0],
      equityPartialRepayments: futureHousePrice[0] - partialRepayment[0],
    },
    {
      title: "5 years",
      propertyValue: futureHousePrice[5],
      amountOwed: noRepayments[5],
      equity: equityRetained(5, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[5],
      equityPartialRepayments: futureHousePrice[5] - partialRepayment[5],
    },
    {
      title: "10 years",
      propertyValue: futureHousePrice[10],
      amountOwed: noRepayments[10],
      equity: equityRetained(10, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[10],
      equityPartialRepayments: futureHousePrice[10] - partialRepayment[10],
    },
    {
      title: "15 years",
      propertyValue: futureHousePrice[15],
      amountOwed: noRepayments[15],
      equity: equityRetained(15, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[15],
      equityPartialRepayments: futureHousePrice[15] - partialRepayment[15],
    },
    {
      title: "20 years",
      propertyValue: futureHousePrice[20],
      amountOwed: noRepayments[20],
      equity: equityRetained(20, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[20],
      equityPartialRepayments: futureHousePrice[20] - partialRepayment[20],
    },
    {
      title: "25 years",
      propertyValue: futureHousePrice[25],
      amountOwed: noRepayments[25],
      equity: equityRetained(25, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[25],
      equityPartialRepayments: futureHousePrice[25] - partialRepayment[25],
    }
  ];
}

export const partialRepaymentOutput = (input) => {
  const { loanTaken, interestTaken, capitalValue } = input;
  const monthlyInterestRepayment = parseFloat((loanTaken * (interestTaken * 0.01) / 12).toFixed(2));
  const futureHousePrice = seriesFutureHousePrice(input);
  console.log(futureHousePrice);
  const cappedWithHp = (arr) => arr.map((x, index) => ((parseFloat(x, 10) > parseFloat(futureHousePrice[index], 10)) ? futureHousePrice[index] : x));
  const noRepayments = cappedWithHp(seriesNoRepayment(input));

  const payingOffInterest = cappedWithHp(series({ ...input, stopRepayment: input.stopPayingOffInterest, monthlyPayment: monthlyInterestRepayment }, "payingOffInterest" ));
  const partialRepayment = cappedWithHp(stopAfterZero(series({ ...input, stopRepayment: input.stopPartialRepayment, monthlyPayment: capitalValue })));
  const maxStopAfter = partialRepayment.findIndex(x => (x <= 0));
  const tableData = futureTableCalc(futureHousePrice, noRepayments, partialRepayment);
  const amountOwed = noRepayments;
  const amountOwedPartialRepayments = partialRepayment;
  return {
    monthlyInterestRepayment,
    maxStopAfter,
    series: {
      amountOwed,
      amountOwedPartialRepayments,
      futureHousePrice,
      noRepayments,
      payingOffInterest,
      partialRepayment,
      tableData
    }
  };
};



// WEBPACK FOOTER //
// ./src/services/PartialRepaymentCalc.js